import { Field, GenericField } from 'redux-form';

import { InputFileProps } from './InputFile/InputFile';
import { InputFileCardProps } from './InputFileCard/InputFileCard';
import { InputSelectProps } from './InputSelect/InputSelect';
import { InputTextProps } from './InputText/InputText';
import { InputTextareaProps } from './InputTextarea/InputTextarea';

export { InputFile } from './InputFile/InputFile';
export { InputFileCard } from './InputFileCard/InputFileCard';
export { InputOtp } from './InputOtp/InputOtp';
export { InputSelect } from './InputSelect/InputSelect';
export { InputText } from './InputText/InputText';
export { InputTextarea } from './InputTextarea/InputTextarea';

export type FieldFile = GenericField<InputFileProps>;
export type FieldFileCard = GenericField<InputFileCardProps>;
export type FieldSelect = GenericField<InputSelectProps>;
export type FieldText = GenericField<InputTextProps>;
export type FieldTextarea = GenericField<InputTextareaProps>;

export const FieldFile = Field as new () => GenericField<InputFileProps>;
export const FieldFileCard = Field as new () => GenericField<InputFileCardProps>;
export const FieldSelect = Field as new () => GenericField<InputSelectProps>;
export const FieldText = Field as new () => GenericField<InputTextProps>;
export const FieldTextarea = Field as new () => GenericField<InputTextareaProps>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Input/index.ts